export function isBtnSpinning(btnElem: HTMLElement): boolean {
  return (
    btnElem.classList.contains("throbber") || btnElem.classList.contains("spin")
  );
}
